<app-block-factory
  [blockId]="blockId"
  *ngIf="blockId"
></app-block-factory>
